import React from 'react';
import { Cloud, Server, Users, Settings, Headphones, BookOpen, Globe } from 'lucide-react';

const Services: React.FC = () => {
  const services = [
    {
      icon: <Cloud />,
      title: "Moodle Cloud - ¡LISTO PARA USAR!",
      description: "Tu plataforma Moodle completamente configurada y lista para comenzar a enseñar desde el primer día. Hosting optimizado + administración completa incluida.",
      features: [
        "Configuración instantánea",
        "Hosting optimizado para Moodle",
        "Administración técnica completa",
        "Actualizaciones automáticas",
        "Backups diarios incluidos",
        "Soporte técnico 24/7"
      ],
      isPromo: true
    },
    {
      icon: <Cloud />,
      title: "Moodle Cloud Hosting",
      description: "Hosting especializado en Moodle con infraestructura optimizada, backups automáticos y alta disponibilidad para tu plataforma educativa.",
      features: [
        "Servidores optimizados para Moodle",
        "Certificados SSL incluidos",
        "Backups automáticos diarios",
        "CDN global integrado"
      ]
    },
    {
      icon: <Server />,
      title: "Administración Completa",
      description: "Gestión integral de tu plataforma Moodle: actualizaciones, mantenimiento, optimización y monitoreo continuo por expertos.",
      features: [
        "Actualizaciones de seguridad",
        "Monitoreo 24/7",
        "Optimización de rendimiento",
        "Gestión de plugins"
      ]
    },
    {
      icon: <Users />,
      title: "Migración de Datos",
      description: "Migramos tu plataforma existente a nuestros servidores sin pérdida de datos, conservando toda la estructura y contenido.",
      features: [
        "Migración sin tiempo de inactividad",
        "Preservación de datos completa",
        "Pruebas exhaustivas",
        "Soporte durante la transición"
      ]
    },
    {
      icon: <Settings />,
      title: "Personalización Avanzada",
      description: "Adaptamos Moodle a las necesidades específicas de tu institución con temas personalizados y funcionalidades a medida.",
      features: [
        "Temas corporativos únicos",
        "Plugins personalizados",
        "Integración con sistemas externos",
        "Desarrollo a medida"
      ]
    },
    {
      icon: <Headphones />,
      title: "Soporte Técnico",
      description: "Equipo de expertos certificados en Moodle disponible para resolver cualquier incidencia y optimizar tu experiencia.",
      features: [
        "Soporte multicanal",
        "Respuesta en menos de 2 horas",
        "Expertos certificados Moodle",
        "Base de conocimientos exclusiva"
      ]
    },
    {
      icon: <BookOpen />,
      title: "Capacitación y Consultoría",
      description: "Formamos a tu equipo en el uso avanzado de Moodle y proporcionamos consultoría estratégica para maximizar el ROI educativo.",
      features: [
        "Talleres presenciales y virtuales",
        "Materiales de formación incluidos",
        "Certificaciones oficiales",
        "Consultoría estratégica"
      ]
    }
  ];

  return (
    <section id="servicios" className="services">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Nuestros Servicios</h2>
          <p className="section-subtitle">
            Soluciones integrales para tu plataforma Moodle, desde el hosting hasta la capacitación
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className={`service-card ${service.isPromo ? 'service-card-promo' : ''}`}>
              {service.isPromo && <div className="promo-ribbon">¡GRATIS!</div>}
              <div className="service-icon">
                {service.icon}
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="service-feature">
                    {feature}
                  </li>
                ))}
              </ul>
              {service.isPromo && (
                <div className="service-cta">
                  <a href="#contacto" className="btn btn-accent">
                    ¡Comenzar Ahora!
                  </a>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="services-cta">
          <div className="cta-content">
            <h3>¿Necesitas una solución personalizada?</h3>
            <p>Contáctanos para discutir tus requerimientos específicos y crear un plan adaptado a tu institución.</p>
            <a href="#contacto" className="btn btn-primary">Solicitar Consulta Gratuita</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;